<template>
  <SingleSQ
    class="mb-14"
    :questionData="questionData"
    :btnWidth="250"
    :oneOption="true"
    :pendingOption="false"
    :sq_numberData="'sq_thirtyNineData'"
    :sqOptions="[40]"
    @editQuestion="editQuestion"
    @deleteQuestion="deleteQuestion"
    @checkIfHistoryModeContinues="checkIfHistoryModeContinues"
    @reduceDecreasing="reduceDecreasing"
    @handleProgress="handleProgress">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'
import { singleQuesMethods } from '@/mixins/singleQuesMethods'

export default {
  name: 'SQuesThirtyNine',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    handleProgress (value) {
      if (value === 1) {
        this.$emit('handleProgress', 97)
      } else if (value === 3) {
        this.$emit('handleProgress', 95)
      }
    }
  },
  mixins: [singleQuesMethods]
}
</script>
